
export let ROOT_URL 	= 'https://travelinsurance.zurich.co.jp/TravelWL';
export let ROOT_TITLE 	= '｜チューリッヒの旅行保険';

/**
 * ビューの定義
 * name:		名称（？）
 * title:		タブタイトル
 * virtualPage:	URL
 * page_type:	ページタイプ
 * extraFlg: 	データレイヤー追加フラグ
 */
export const VIEW_DEFINE_JSON = [
	{
		name: 					'screen1',
		title: 					'旅行内容の確認',
		virtualPage: 			'/step1_riskfactor',
		page_type:				'Quote',
		extraFlg:				false
	},
	{
		name: 					'screen2',
		title: 					'保険プランの選択',
		virtualPage: 			'/step2_plan',
		page_type:				'Quote',
		quote_prev_expiry_date: '',					
		quote_expiry_date: 		'',
		quote_amt: 				'',
		endorser: 				'',
		country: 				'',
		number_of_parson: 		'',
		purpose: 				'',
		extraFlg:				true
	},
	{
		name: 					'screen3',
		title: 					'重要項目のご確認',
		virtualPage: 			'/step3_important',
		page_type:				'Contract',
		extraFlg:				false
	},
	{
		name: 					'screen4_1',
		title: 					'メールアドレスの登録',
		virtualPage: 			'/step4_mail-registration',
		page_type:				'Contract',
		extraFlg:				false
	},
	{
		name: 					'screen4_2',
		title: 					'メールアドレスの登録完了',
		virtualPage: 			'/step4_mail-finish',
		page_type:				'Contract',
		extraFlg:				false
	},
	{
		name: 					'screen5',
		title: 					'お客さま情報の登録',
		virtualPage: 			'/step5_personal-information',
		page_type:				'Contract',
		quote_prev_expiry_date: '',					
		quote_expiry_date: 		'',
		quote_amt: 				'',
		quote_id: 				'',
		endorser: 				'',
		country: 				'',
		number_of_parson: 		'',
		purpose: 				'',
		extraFlg:				true
	},
	{
		name: 					'screen6',
		title: 					'申込内容の確認',
		virtualPage: 			'/step6_confirm',
		page_type:				'Contract',
		extraFlg:				false
	},
	{
		name: 					'screen7_1',
		title: 					'保険料のお支払い',
		virtualPage: 			'/step7_payment',
		page_type:				'Contract',
		extraFlg:				false
	},
	{
		name: 					'screen7_2',
		title: 					'クレジットカード払い',
		virtualPage: 			'/step7_creditcard',
		page_type:				'Contract',
		extraFlg:				false
	},
	{
		name: 					'screen8',
		title: 					'ご契約手続き完了',
		virtualPage: 			'/step8_make-contract',
		page_type:				'Contract',
		quote_prev_expiry_date: '',					 
		quote_expiry_date: 		'',
		quote_amt: 				'',
		quote_id: 				'',
		contract_amt:			'',
		contract_paytype:		'',
		endorser: 				'',
		country: 				'',
		number_of_parson: 		'',
		purpose: 				'',
		extraFlg:				true
	},
	{
		name: 					'screen99',
		title: 					'エラー通知',
		virtualPage: 			'/error',
		page_type:				'Contract',
		extraFlg:				false
	},
	// WRQ-2990_旅行保険　直扱販売のための対応 START
	{
		name: 					'screen99_2',
		title: 					'エラー通知',
		virtualPage: 			'/b_error',
		page_type:				'Contract',
		extraFlg:				false
	},
	// WRQ-2990_旅行保険　直扱販売のための対応 END
];
